import React from 'react';
import { NavLink, Route, Switch } from 'react-router-dom';
import { Divider, Dropdown, Menu } from 'semantic-ui-react';

import { DescriptorDeUsuario } from 'src/descriptor';
import Alumnos, { puedeVerFichaDeAlumno } from 'src/modulos/Alumnos';
import AsistenciaPrincipal from 'src/modulos/Asistencia';
import Cobranzas from 'src/modulos/Cobranzas/CobranzasPrincipal';
import Horarios from 'src/modulos/Horarios';
import MatriculasPrincipal from 'src/modulos/Matriculas/MatriculasPrincipal';
import Supervision from 'src/modulos/Matriculas/Supervision';
import OrientacionPrincipal from 'src/modulos/Orientacion/OrientacionPrincipal';
import PsicopedagogiaPrincipal from 'src/modulos/Psicopedagogia/PsicopedagogiaPrincipal';
import RecepcionPrincipal from 'src/modulos/Recepcion/RecepcionPrincipal';
import Recuperaciones from 'src/modulos/Recuperaciones';

const menuStyle: React.CSSProperties = {
    backgroundColor: '#eee',
};

const PaginaPrincipal: React.FunctionComponent<{
    readonly usuarioActual: DescriptorDeUsuario;
    alCerrarSesion(): void;
}> = ({ usuarioActual, alCerrarSesion }) => (
    <>
        <nav>
            <Menu fixed='top' size='small' style={menuStyle}>
                {puedeVerFichaDeAlumno(usuarioActual) && (
                    <Menu.Item as={NavLink} to='/alumnos' content='Alumnos' />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('administrador_asistencias') && (
                    <Menu.Item as={NavLink} to='/asistencia' content='Asistencia' />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones(
                    'supervisor',
                    'asesor',
                    'asistente_matriculas',
                ) && <Menu.Item as={NavLink} to='/matriculas' content='Matrículas' />}

                {usuarioActual.tieneAlgunaDeEstasFunciones('supervisor') && (
                    <Menu.Item as={NavLink} to='/supervision' content='Supervisión' />
                )}

                <Menu.Item as={NavLink} to='/horarios' content='Horarios' />

                {usuarioActual.tieneAlgunaDeEstasFunciones('encargado_docente') && (
                    <Menu.Item as={NavLink} to='/recuperaciones' content='Recuperaciones' />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('recaudador') && (
                    <Menu.Item as={NavLink} to='/cobranzas' content='Cobranzas' />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('orientador') && (
                    <Menu.Item as={NavLink} to='/orientacion' content='Orientación' />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('psicopedagogo') && (
                    <Menu.Item as={NavLink} to='/psicopedagogia' content='Psicopedagogía' />
                )}

                <Menu.Menu position='right'>
                    <Dropdown item icon='user'>
                        <Dropdown.Menu>
                            <Dropdown.Header>
                                {usuarioActual.nombrePersonal.primerNombre}
                            </Dropdown.Header>

                            <Dropdown.Item
                                icon='sign out'
                                text='Cerrar sesión'
                                onClick={alCerrarSesion}
                            />
                        </Dropdown.Menu>
                    </Dropdown>
                </Menu.Menu>
            </Menu>
            <div style={{ height: '50px' }} />
        </nav>

        <main>
            <Switch>
                {puedeVerFichaDeAlumno(usuarioActual) && (
                    <Route path='/alumnos' component={Alumnos} />
                )}
                {usuarioActual.tieneAlgunaDeEstasFunciones('administrador_asistencias') && (
                    <Route path='/asistencia' component={AsistenciaPrincipal} />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('supervisor') && (
                    <Route path='/recepcion' component={RecepcionPrincipal} />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones(
                    'supervisor',
                    'asesor',
                    'asistente_matriculas',
                ) && <Route path='/matriculas' component={MatriculasPrincipal} />}

                {usuarioActual.tieneAlgunaDeEstasFunciones('supervisor') && (
                    <Route path='/supervision' component={Supervision} />
                )}

                <Route path='/horarios' component={Horarios} />

                {usuarioActual.tieneAlgunaDeEstasFunciones('encargado_docente') && (
                    <Route path='/recuperaciones' component={Recuperaciones} />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('recaudador') && (
                    <Route path='/cobranzas' component={Cobranzas} />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('orientador') && (
                    <Route path='/orientacion' component={OrientacionPrincipal} />
                )}

                {usuarioActual.tieneAlgunaDeEstasFunciones('psicopedagogo') && (
                    <Route path='/psicopedagogia' component={PsicopedagogiaPrincipal} />
                )}
            </Switch>
        </main>

        <footer>
            <Divider hidden section clearing />
        </footer>
    </>
);

export default PaginaPrincipal;



// WEBPACK FOOTER //
// ./src/paginas/PaginaPrincipal/index.tsx